import type { DeepReadonly } from '@itandi/itandi-bb-ui';
import type { ReactNode } from 'react';
import type React from 'react';

type Props = DeepReadonly<{
  children: ReactNode;
}>;

export const TableBody: React.FC<Props> = ({ children }: Props) => (
  <tbody>{children}</tbody>
);
